
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Get environment variables with fallbacks
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://csozwfcytrcqzctrqooj.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNzb3p3ZmN5dHJjcXpjdHJxb29qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIwOTQ0NDYsImV4cCI6MjA1NzY3MDQ0Nn0.-wyd1HATSHQKH-g_JaAPA_onQ8ytZVM4Fiuy-Mj4cfs';

// Log initialization (but not keys) in development mode
if (import.meta.env.DEV) {
  console.log('Initializing Supabase client with URL:', SUPABASE_URL ? 'URL provided' : 'Using fallback URL');
}

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    storage: {
      // Use localStorage for persistent session storage
      getItem: (key) => {
        try {
          const item = localStorage.getItem(key);
          return item;
        } catch (error) {
          console.error('Error getting auth session from localStorage:', error);
          return null;
        }
      },
      setItem: (key, value) => {
        try {
          localStorage.setItem(key, value);
        } catch (error) {
          console.error('Error storing auth session to localStorage:', error);
        }
      },
      removeItem: (key) => {
        try {
          localStorage.removeItem(key);
        } catch (error) {
          console.error('Error removing auth session from localStorage:', error);
        }
      }
    }
  }
});
